/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jump_Confirmation_Description_NoteInputs */

const en_jump_confirmation_description_note = /** @type {(inputs: Jump_Confirmation_Description_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Pass rewards still require a Plus subscription.`)
};

const ar_jump_confirmation_description_note = /** @type {(inputs: Jump_Confirmation_Description_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تتطلب مكافآت بطاقة Plus اشتراك Plus.`)
};

const de_jump_confirmation_description_note = /** @type {(inputs: Jump_Confirmation_Description_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus-Pass-Belohnungen erfordern ein Plus-Abo.`)
};

const es_jump_confirmation_description_note = /** @type {(inputs: Jump_Confirmation_Description_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las recompensas del Pase Plus requieren una suscripción Plus.`)
};

const fr_jump_confirmation_description_note = /** @type {(inputs: Jump_Confirmation_Description_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les récompenses du Passe Plus nécessitent un abonnement Plus.`)
};

const it_jump_confirmation_description_note = /** @type {(inputs: Jump_Confirmation_Description_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I premi del Pass Plus richiedono un abbonamento Plus.`)
};

const ja_jump_confirmation_description_note = /** @type {(inputs: Jump_Confirmation_Description_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusパス報酬の受け取りにはPlus登録が必要です。`)
};

const ko_jump_confirmation_description_note = /** @type {(inputs: Jump_Confirmation_Description_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 패스 보상은 Plus 구독이 필요합니다.`)
};

const pt_br_jump_confirmation_description_note = /** @type {(inputs: Jump_Confirmation_Description_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As recompensas do Passaporte Plus exigem uma assinatura Plus.`)
};

const ru_jump_confirmation_description_note = /** @type {(inputs: Jump_Confirmation_Description_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для наград Plus-пропуска нужна подписка Plus.`)
};

const th_jump_confirmation_description_note = /** @type {(inputs: Jump_Confirmation_Description_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รางวัลบัตรผ่าน Plus ต้องมีการสมัคร Plus`)
};

const tr_jump_confirmation_description_note = /** @type {(inputs: Jump_Confirmation_Description_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Bilet ödülleri için Plus aboneliği gerekir.`)
};

const zh_cn_jump_confirmation_description_note = /** @type {(inputs: Jump_Confirmation_Description_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 通行证奖励仍需订阅才可领取。`)
};

const zh_tw_jump_confirmation_description_note = /** @type {(inputs: Jump_Confirmation_Description_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 通行證獎勵仍需訂閱才可以領取。`)
};

/**
* | output |
* | --- |
* | "Plus Pass rewards still require a Plus subscription." |
*
* @param {Jump_Confirmation_Description_NoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const jump_confirmation_description_note = /** @type {((inputs?: Jump_Confirmation_Description_NoteInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jump_Confirmation_Description_NoteInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jump_confirmation_description_note(inputs)
	if (locale === "ar") return ar_jump_confirmation_description_note(inputs)
	if (locale === "de") return de_jump_confirmation_description_note(inputs)
	if (locale === "es") return es_jump_confirmation_description_note(inputs)
	if (locale === "fr") return fr_jump_confirmation_description_note(inputs)
	if (locale === "it") return it_jump_confirmation_description_note(inputs)
	if (locale === "ja") return ja_jump_confirmation_description_note(inputs)
	if (locale === "ko") return ko_jump_confirmation_description_note(inputs)
	if (locale === "pt_br") return pt_br_jump_confirmation_description_note(inputs)
	if (locale === "ru") return ru_jump_confirmation_description_note(inputs)
	if (locale === "th") return th_jump_confirmation_description_note(inputs)
	if (locale === "tr") return tr_jump_confirmation_description_note(inputs)
	if (locale === "zh_cn") return zh_cn_jump_confirmation_description_note(inputs)
	return zh_tw_jump_confirmation_description_note(inputs)
});